function pad2(n) {
  return String(n).padStart(2, "0");
}

/** Local calendar dates (avoids UTC shift from toISOString). */
export function formatLocalDate(d) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function periodFromMonthYear(month, year) {
  const m = Number(month);
  const y = Number(year);
  const start = new Date(y, m - 1, 1);
  const end = new Date(y, m, 0);
  return {
    period_start: formatLocalDate(start),
    period_end: formatLocalDate(end),
  };
}

export function validateRosterCreate(form) {
  const errors = {};
  if (!form.month || !form.year) errors.period = "Month and year are required";
  return errors;
}

/** Prefer live roster when multiple exist for the same calendar month. */
function rosterMonthRank(roster) {
  const statusScore = {
    archived: 0,
    draft: 1,
    pending_approval: 2,
    approved: 3,
    published: 4,
    frozen: 5,
  };
  return (statusScore[roster?.status] ?? 0) * 1000 + (roster?.version ?? 0);
}

export function dedupeRostersByMonth(rosters) {
  const byMonth = new Map();
  for (const roster of rosters || []) {
    const key = roster.period_start?.slice(0, 7);
    if (!key) continue;
    const existing = byMonth.get(key);
    if (!existing || rosterMonthRank(roster) > rosterMonthRank(existing)) {
      byMonth.set(key, roster);
    }
  }
  return Array.from(byMonth.values()).sort((a, b) =>
    (b.period_start || "").localeCompare(a.period_start || "")
  );
}

export function findRosterForPeriod(rosters, periodStart) {
  if (!periodStart) return null;
  const matches = (rosters || []).filter((r) => r.period_start === periodStart);
  if (!matches.length) return null;
  return matches.reduce((best, r) => (rosterMonthRank(r) > rosterMonthRank(best) ? r : best));
}

export function canEditRosterMetadata(roster) {
  return roster && ["draft", "pending_approval", "approved"].includes(roster.status);
}

export function validateAssignment(assign, roster, existing = [], editingId = null) {
  const errors = {};
  if (!assign.employee_id) errors.employee_id = "Employee is required";
  if (!assign.work_date) errors.work_date = "Date is required";
  if (!assign.shift_id) errors.shift_id = "Shift is required";
  if (!roster) return errors;

  if (assign.work_date) {
    if (assign.work_date < roster.period_start || assign.work_date > roster.period_end) {
      errors.work_date = "Date must be within roster period";
    }
  }

  const dup = existing.find(
    (r) =>
      r.assignment_id !== editingId &&
      r.employee_id === assign.employee_id &&
      r.work_date === assign.work_date &&
      r.status !== "deleted"
  );
  if (dup) errors.work_date = "Employee already assigned on this date";

  if (assign.override_required && !assign.override_reason?.trim()) {
    errors.override_reason = "Override reason is required";
  }

  return errors;
}

export function canEditRoster(roster, isAdmin) {
  if (!roster) return false;
  if (roster.status === "frozen" || roster.status === "archived") return false;
  if (roster.status === "draft" || roster.status === "pending_approval") return true;
  if (roster.status === "approved") return true;
  if (roster.status === "published") return isAdmin;
  return false;
}

export function rosterStatusLabel(status) {
  const map = {
    draft: "Draft",
    pending_approval: "Pending approval",
    approved: "Approved",
    published: "Published",
    frozen: "Frozen",
    archived: "Archived",
  };
  return map[status] || status;
}
